export const borderStyles = {
  default: 'border border-gray-150',
  error: 'border border-error focus:border-error disabled:border-error',
}
